import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'
import { useUser } from '../user/useUser'

export const USER_RSVPS_QUERY_KEY = (userID: string) => ['user-rsvps', userID]

export function useUserRSVPs() {
  const { data: user } = useUser()

  return useQuery({
    queryKey: USER_RSVPS_QUERY_KEY(user?.id ?? ''),
    queryFn: async () => {
      if (!user) return []
      return dataSource.getUserEvents(user.id)
    },
    enabled: !!user,
  })
}

